module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('h2', [_vm._v("All Nodes\n\t\t\t\t"), _c('i', {
    staticClass: "fa fa-refresh fa-fw",
    class: {
      'fa-spin': _vm.running
    },
    on: {
      "click": _vm.loadData
    }
  })]), _vm._v(" "), _c('info-error', {
    attrs: {
      "message": _vm.errorMessage
    }
  }), _vm._v(" "), (_vm.table.rows) ? _c('tablegrid', {
    attrs: {
      "columns": _vm.table.columns,
      "data": _vm.table.rows,
      "mail-action": _vm.mailToOwner,
      "edit-action": _vm.editElement,
      "delete-action": _vm.deleteElement
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "actions well"
  }, [(this.$store.getters.user.admin) ? [_c('legend', [_vm._v("Actions")]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/nodes/new"
    }
  }, [_vm._v("New Node")])], 1), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "linklike",
    on: {
      "click": _vm.mailToAll
    }
  }, [_vm._v("Send a mail to all owners")])])]), _vm._v(" "), _c('br')] : _vm._e(), _vm._v(" "), (_vm.table.rows) ? [_c('legend', [_vm._v("Statistics")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Total Nodes")]), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.statTotal))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('chart-online-offline', {
    attrs: {
      "chartData": _vm.chartData
    }
  })], 1)])] : _vm._e()], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Nodes")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-227af4a1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/node/Overview.vue
// module id = 610
// module chunks = 1